import { __ } from '@wordpress/i18n';
import {
	useBlockProps,
	RichText,
	BlockControls,
	AlignmentToolbar,
	InspectorControls,
	MediaUpload,
} from '@wordpress/block-editor';
import classnames from 'classnames';
import './editor.scss';
import {
	PanelBody,
	ToggleControl,
	Button,
	ComboboxControl,
} from '@wordpress/components';
import { useState } from '@wordpress/element';
const agentImage = require( './images/user.jpg' );

const { SelectControl, TextControl } = wp.components;

const timezones = [
	{
		value: 'Africa/Abidjan',
		label: __( 'Africa/Abidjan', 'chat-telegram' ),
	},
	{
		value: 'Africa/Accra',
		label: __( 'Africa/Accra', 'chat-telegram' ),
	},
	{
		value: 'Africa/Addis_Ababa',
		label: __( 'Africa/Addis_Ababa', 'chat-telegram' ),
	},
	{
		value: 'Africa/Algiers',
		label: __( 'Africa/Algiers', 'chat-telegram' ),
	},
	{
		value: 'Africa/Asmara',
		label: __( 'Africa/Asmara', 'chat-telegram' ),
	},
	{
		value: 'Africa/Asmera',
		label: __( 'Africa/Asmera', 'chat-telegram' ),
	},
	{
		value: 'Africa/Bamako',
		label: __( 'Africa/Bamako', 'chat-telegram' ),
	},
	{
		value: 'Africa/Bangui',
		label: __( 'Africa/Bangui', 'chat-telegram' ),
	},
	{
		value: 'Africa/Banjul',
		label: __( 'Africa/Banjul', 'chat-telegram' ),
	},
	{
		value: 'Africa/Bissau',
		label: __( 'Africa/Bissau', 'chat-telegram' ),
	},
	{
		value: 'Africa/Blantyre',
		label: __( 'Africa/Blantyre', 'chat-telegram' ),
	},
	{
		value: 'Africa/Brazzaville',
		label: __( 'Africa/Brazzaville', 'chat-telegram' ),
	},
	{
		value: 'Africa/Bujumbura',
		label: __( 'Africa/Bujumbura', 'chat-telegram' ),
	},
	{
		value: 'Africa/Cairo',
		label: __( 'Africa/Cairo', 'chat-telegram' ),
	},
	{
		value: 'Africa/Casablanca',
		label: __( 'Africa/Casablanca', 'chat-telegram' ),
	},
	{
		value: 'Africa/Ceuta',
		label: __( 'Africa/Ceuta', 'chat-telegram' ),
	},
	{
		value: 'Africa/Conakry',
		label: __( 'Africa/Conakry', 'chat-telegram' ),
	},
	{
		value: 'Africa/Dakar',
		label: __( 'Africa/Dakar', 'chat-telegram' ),
	},
	{
		value: 'Africa/Dar_es_Salaam',
		label: __( 'Africa/Dar_es_Salaam', 'chat-telegram' ),
	},
	{
		value: 'Africa/Djibouti',
		label: __( 'Africa/Djibouti', 'chat-telegram' ),
	},
	{
		value: 'Africa/Douala',
		label: __( 'Africa/Douala', 'chat-telegram' ),
	},
	{
		value: 'Africa/El_Aaiun',
		label: __( 'Africa/El_Aaiun', 'chat-telegram' ),
	},
	{
		value: 'Africa/Freetown',
		label: __( 'Africa/Freetown', 'chat-telegram' ),
	},
	{
		value: 'Africa/Gaborone',
		label: __( 'Africa/Gaborone', 'chat-telegram' ),
	},
	{
		value: 'Africa/Harare',
		label: __( 'Africa/Harare', 'chat-telegram' ),
	},
	{
		value: 'Africa/Johannesburg',
		label: __( 'Africa/Johannesburg', 'chat-telegram' ),
	},
	{
		value: 'Africa/Juba',
		label: __( 'Africa/Juba', 'chat-telegram' ),
	},
	{
		value: 'Africa/Kampala',
		label: __( 'Africa/Kampala', 'chat-telegram' ),
	},
	{
		value: 'Africa/Khartoum',
		label: __( 'Africa/Khartoum', 'chat-telegram' ),
	},
	{
		value: 'Africa/Kigali',
		label: __( 'Africa/Kigali', 'chat-telegram' ),
	},
	{
		value: 'Africa/Kinshasa',
		label: __( 'Africa/Kinshasa', 'chat-telegram' ),
	},
	{
		value: 'Africa/Lagos',
		label: __( 'Africa/Lagos', 'chat-telegram' ),
	},
	{
		value: 'Africa/Libreville',
		label: __( 'Africa/Libreville', 'chat-telegram' ),
	},
	{
		value: 'Africa/Lome',
		label: __( 'Africa/Lome', 'chat-telegram' ),
	},
	{
		value: 'Africa/Luanda',
		label: __( 'Africa/Luanda', 'chat-telegram' ),
	},
	{
		value: 'Africa/Lubumbashi',
		label: __( 'Africa/Lubumbashi', 'chat-telegram' ),
	},
	{
		value: 'Africa/Lusaka',
		label: __( 'Africa/Lusaka', 'chat-telegram' ),
	},
	{
		value: 'Africa/Malabo',
		label: __( 'Africa/Malabo', 'chat-telegram' ),
	},
	{
		value: 'Africa/Maputo',
		label: __( 'Africa/Maputo', 'chat-telegram' ),
	},
	{
		value: 'Africa/Maseru',
		label: __( 'Africa/Maseru', 'chat-telegram' ),
	},
	{
		value: 'Africa/Mbabane',
		label: __( 'Africa/Mbabane', 'chat-telegram' ),
	},
	{
		value: 'Africa/Mogadishu',
		label: __( 'Africa/Mogadishu', 'chat-telegram' ),
	},
	{
		value: 'Africa/Monrovia',
		label: __( 'Africa/Monrovia', 'chat-telegram' ),
	},
	{
		value: 'Africa/Nairobi',
		label: __( 'Africa/Nairobi', 'chat-telegram' ),
	},
	{
		value: 'Africa/Ndjamena',
		label: __( 'Africa/Ndjamena', 'chat-telegram' ),
	},
	{
		value: 'Africa/Niamey',
		label: __( 'Africa/Niamey', 'chat-telegram' ),
	},
	{
		value: 'Africa/Nouakchott',
		label: __( 'Africa/Nouakchott', 'chat-telegram' ),
	},
	{
		value: 'Africa/Ouagadougou',
		label: __( 'Africa/Ouagadougou', 'chat-telegram' ),
	},
	{
		value: 'Africa/Porto-Novo',
		label: __( 'Africa/Porto-Novo', 'chat-telegram' ),
	},
	{
		value: 'Africa/Sao_Tome',
		label: __( 'Africa/Sao_Tome', 'chat-telegram' ),
	},
	{
		value: 'Africa/Timbuktu',
		label: __( 'Africa/Timbuktu', 'chat-telegram' ),
	},
	{
		value: 'Africa/Tripoli',
		label: __( 'Africa/Tripoli', 'chat-telegram' ),
	},
	{
		value: 'Africa/Tunis',
		label: __( 'Africa/Tunis', 'chat-telegram' ),
	},
	{
		value: 'Africa/Windhoek',
		label: __( 'Africa/Windhoek', 'chat-telegram' ),
	},
	{
		value: 'America/Adak',
		label: __( 'America/Adak', 'chat-telegram' ),
	},
	{
		value: 'America/Anchorage',
		label: __( 'America/Anchorage', 'chat-telegram' ),
	},
	{
		value: 'America/Anguilla',
		label: __( 'America/Anguilla', 'chat-telegram' ),
	},
	{
		value: 'America/Antigua',
		label: __( 'America/Antigua', 'chat-telegram' ),
	},
	{
		value: 'America/Araguaina',
		label: __( 'America/Araguaina', 'chat-telegram' ),
	},
	{
		value: 'America/Argentina/Buenos_Aires',
		label: __( 'America/Argentina/Buenos_Aires', 'chat-telegram' ),
	},
	{
		value: 'America/Argentina/Catamarca',
		label: __( 'America/Argentina/Catamarca', 'chat-telegram' ),
	},
	{
		value: 'America/Argentina/ComodRivadavia',
		label: __( 'America/Argentina/ComodRivadavia', 'chat-telegram' ),
	},
	{
		value: 'America/Argentina/Cordoba',
		label: __( 'America/Argentina/Cordoba', 'chat-telegram' ),
	},
	{
		value: 'America/Argentina/Jujuy',
		label: __( 'America/Argentina/Jujuy', 'chat-telegram' ),
	},
	{
		value: 'America/Argentina/La_Rioja',
		label: __( 'America/Argentina/La_Rioja', 'chat-telegram' ),
	},
	{
		value: 'America/Argentina/Mendoza',
		label: __( 'America/Argentina/Mendoza', 'chat-telegram' ),
	},
	{
		value: 'America/Argentina/Rio_Gallegos',
		label: __( 'America/Argentina/Rio_Gallegos', 'chat-telegram' ),
	},
	{
		value: 'America/Argentina/Salta',
		label: __( 'America/Argentina/Salta', 'chat-telegram' ),
	},
	{
		value: 'America/Argentina/San_Juan',
		label: __( 'America/Argentina/San_Juan', 'chat-telegram' ),
	},
	{
		value: 'America/Argentina/San_Luis',
		label: __( 'America/Argentina/San_Luis', 'chat-telegram' ),
	},
	{
		value: 'America/Argentina/Tucuman',
		label: __( 'America/Argentina/Tucuman', 'chat-telegram' ),
	},
	{
		value: 'America/Argentina/Ushuaia',
		label: __( 'America/Argentina/Ushuaia', 'chat-telegram' ),
	},
	{
		value: 'America/Aruba',
		label: __( 'America/Aruba', 'chat-telegram' ),
	},
	{
		value: 'America/Asuncion',
		label: __( 'America/Asuncion', 'chat-telegram' ),
	},
	{
		value: 'America/Atikokan',
		label: __( 'America/Atikokan', 'chat-telegram' ),
	},
	{
		value: 'America/Atka',
		label: __( 'America/Atka', 'chat-telegram' ),
	},
	{
		value: 'America/Bahia',
		label: __( 'America/Bahia', 'chat-telegram' ),
	},
	{
		value: 'America/Bahia_Banderas',
		label: __( 'America/Bahia_Banderas', 'chat-telegram' ),
	},
	{
		value: 'America/Barbados',
		label: __( 'America/Barbados', 'chat-telegram' ),
	},
	{
		value: 'America/Belem',
		label: __( 'America/Belem', 'chat-telegram' ),
	},
	{
		value: 'America/Belize',
		label: __( 'America/Belize', 'chat-telegram' ),
	},
	{
		value: 'America/Blanc-Sablon',
		label: __( 'America/Blanc-Sablon', 'chat-telegram' ),
	},
	{
		value: 'America/Boa_Vista',
		label: __( 'America/Boa_Vista', 'chat-telegram' ),
	},
	{
		value: 'America/Bogota',
		label: __( 'America/Bogota', 'chat-telegram' ),
	},
	{
		value: 'America/Boise',
		label: __( 'America/Boise', 'chat-telegram' ),
	},
	{
		value: 'America/Buenos_Aires',
		label: __( 'America/Buenos_Aires', 'chat-telegram' ),
	},
	{
		value: 'America/Cambridge_Bay',
		label: __( 'America/Cambridge_Bay', 'chat-telegram' ),
	},
	{
		value: 'America/Campo_Grande',
		label: __( 'America/Campo_Grande', 'chat-telegram' ),
	},
	{
		value: 'America/Cancun',
		label: __( 'America/Cancun', 'chat-telegram' ),
	},
	{
		value: 'America/Caracas',
		label: __( 'America/Caracas', 'chat-telegram' ),
	},
	{
		value: 'America/Catamarca',
		label: __( 'America/Catamarca', 'chat-telegram' ),
	},
	{
		value: 'America/Cayenne',
		label: __( 'America/Cayenne', 'chat-telegram' ),
	},
	{
		value: 'America/Cayman',
		label: __( 'America/Cayman', 'chat-telegram' ),
	},
	{
		value: 'America/Chicago',
		label: __( 'America/Chicago', 'chat-telegram' ),
	},
	{
		value: 'America/Chihuahua',
		label: __( 'America/Chihuahua', 'chat-telegram' ),
	},
	{
		value: 'America/Coral_Harbour',
		label: __( 'America/Coral_Harbour', 'chat-telegram' ),
	},
	{
		value: 'America/Cordoba',
		label: __( 'America/Cordoba', 'chat-telegram' ),
	},
	{
		value: 'America/Costa_Rica',
		label: __( 'America/Costa_Rica', 'chat-telegram' ),
	},
	{
		value: 'America/Creston',
		label: __( 'America/Creston', 'chat-telegram' ),
	},
	{
		value: 'America/Cuiaba',
		label: __( 'America/Cuiaba', 'chat-telegram' ),
	},
	{
		value: 'America/Curacao',
		label: __( 'America/Curacao', 'chat-telegram' ),
	},
	{
		value: 'America/Danmarkshavn',
		label: __( 'America/Danmarkshavn', 'chat-telegram' ),
	},
	{
		value: 'America/Dawson',
		label: __( 'America/Dawson', 'chat-telegram' ),
	},
	{
		value: 'America/Dawson_Creek',
		label: __( 'America/Dawson_Creek', 'chat-telegram' ),
	},
	{
		value: 'America/Denver',
		label: __( 'America/Denver', 'chat-telegram' ),
	},
	{
		value: 'America/Detroit',
		label: __( 'America/Detroit', 'chat-telegram' ),
	},
	{
		value: 'America/Dominica',
		label: __( 'America/Dominica', 'chat-telegram' ),
	},
	{
		value: 'America/Edmonton',
		label: __( 'America/Edmonton', 'chat-telegram' ),
	},
	{
		value: 'America/Eirunepe',
		label: __( 'America/Eirunepe', 'chat-telegram' ),
	},
	{
		value: 'America/El_Salvador',
		label: __( 'America/El_Salvador', 'chat-telegram' ),
	},
	{
		value: 'America/Ensenada',
		label: __( 'America/Ensenada', 'chat-telegram' ),
	},
	{
		value: 'America/Fort_Nelson',
		label: __( 'America/Fort_Nelson', 'chat-telegram' ),
	},
	{
		value: 'America/Fort_Wayne',
		label: __( 'America/Fort_Wayne', 'chat-telegram' ),
	},
	{
		value: 'America/Fortaleza',
		label: __( 'America/Fortaleza', 'chat-telegram' ),
	},
	{
		value: 'America/Glace_Bay',
		label: __( 'America/Glace_Bay', 'chat-telegram' ),
	},
	{
		value: 'America/Godthab',
		label: __( 'America/Godthab', 'chat-telegram' ),
	},
	{
		value: 'America/Goose_Bay',
		label: __( 'America/Goose_Bay', 'chat-telegram' ),
	},
	{
		value: 'America/Grand_Turk',
		label: __( 'America/Grand_Turk', 'chat-telegram' ),
	},
	{
		value: 'America/Grenada',
		label: __( 'America/Grenada', 'chat-telegram' ),
	},
	{
		value: 'America/Guadeloupe',
		label: __( 'America/Guadeloupe', 'chat-telegram' ),
	},
	{
		value: 'America/Guatemala',
		label: __( 'America/Guatemala', 'chat-telegram' ),
	},
	{
		value: 'America/Guayaquil',
		label: __( 'America/Guayaquil', 'chat-telegram' ),
	},
	{
		value: 'America/Guyana',
		label: __( 'America/Guyana', 'chat-telegram' ),
	},
	{
		value: 'America/Halifax',
		label: __( 'America/Halifax', 'chat-telegram' ),
	},
	{
		value: 'America/Havana',
		label: __( 'America/Havana', 'chat-telegram' ),
	},
	{
		value: 'America/Hermosillo',
		label: __( 'America/Hermosillo', 'chat-telegram' ),
	},
	{
		value: 'America/Indiana/Indianapolis',
		label: __( 'America/Indiana/Indianapolis', 'chat-telegram' ),
	},
	{
		value: 'America/Indiana/Knox',
		label: __( 'America/Indiana/Knox', 'chat-telegram' ),
	},
	{
		value: 'America/Indiana/Marengo',
		label: __( 'America/Indiana/Marengo', 'chat-telegram' ),
	},
	{
		value: 'America/Indiana/Petersburg',
		label: __( 'America/Indiana/Petersburg', 'chat-telegram' ),
	},
	{
		value: 'America/Indiana/Tell_City',
		label: __( 'America/Indiana/Tell_City', 'chat-telegram' ),
	},
	{
		value: 'America/Indiana/Vevay',
		label: __( 'America/Indiana/Vevay', 'chat-telegram' ),
	},
	{
		value: 'America/Indiana/Vincennes',
		label: __( 'America/Indiana/Vincennes', 'chat-telegram' ),
	},
	{
		value: 'America/Indiana/Winamac',
		label: __( 'America/Indiana/Winamac', 'chat-telegram' ),
	},
	{
		value: 'America/Indianapolis',
		label: __( 'America/Indianapolis', 'chat-telegram' ),
	},
	{
		value: 'America/Inuvik',
		label: __( 'America/Inuvik', 'chat-telegram' ),
	},
	{
		value: 'America/Iqaluit',
		label: __( 'America/Iqaluit', 'chat-telegram' ),
	},
	{
		value: 'America/Jamaica',
		label: __( 'America/Jamaica', 'chat-telegram' ),
	},
	{
		value: 'America/Jujuy',
		label: __( 'America/Jujuy', 'chat-telegram' ),
	},
	{
		value: 'America/Juneau',
		label: __( 'America/Juneau', 'chat-telegram' ),
	},
	{
		value: 'America/Kentucky/Louisville',
		label: __( 'America/Kentucky/Louisville', 'chat-telegram' ),
	},
	{
		value: 'America/Kentucky/Monticello',
		label: __( 'America/Kentucky/Monticello', 'chat-telegram' ),
	},
	{
		value: 'America/Knox_IN',
		label: __( 'America/Knox_IN', 'chat-telegram' ),
	},
	{
		value: 'America/Kralendijk',
		label: __( 'America/Kralendijk', 'chat-telegram' ),
	},
	{
		value: 'America/La_Paz',
		label: __( 'America/La_Paz', 'chat-telegram' ),
	},
	{
		value: 'America/Lima',
		label: __( 'America/Lima', 'chat-telegram' ),
	},
	{
		value: 'America/Los_Angeles',
		label: __( 'America/Los_Angeles', 'chat-telegram' ),
	},
	{
		value: 'America/Louisville',
		label: __( 'America/Louisville', 'chat-telegram' ),
	},
	{
		value: 'America/Lower_Princes',
		label: __( 'America/Lower_Princes', 'chat-telegram' ),
	},
	{
		value: 'America/Maceio',
		label: __( 'America/Maceio', 'chat-telegram' ),
	},
	{
		value: 'America/Managua',
		label: __( 'America/Managua', 'chat-telegram' ),
	},
	{
		value: 'America/Manaus',
		label: __( 'America/Manaus', 'chat-telegram' ),
	},
	{
		value: 'America/Marigot',
		label: __( 'America/Marigot', 'chat-telegram' ),
	},
	{
		value: 'America/Martinique',
		label: __( 'America/Martinique', 'chat-telegram' ),
	},
	{
		value: 'America/Matamoros',
		label: __( 'America/Matamoros', 'chat-telegram' ),
	},
	{
		value: 'America/Mazatlan',
		label: __( 'America/Mazatlan', 'chat-telegram' ),
	},
	{
		value: 'America/Mendoza',
		label: __( 'America/Mendoza', 'chat-telegram' ),
	},
	{
		value: 'America/Menominee',
		label: __( 'America/Menominee', 'chat-telegram' ),
	},
	{
		value: 'America/Merida',
		label: __( 'America/Merida', 'chat-telegram' ),
	},
	{
		value: 'America/Metlakatla',
		label: __( 'America/Metlakatla', 'chat-telegram' ),
	},
	{
		value: 'America/Mexico_City',
		label: __( 'America/Mexico_City', 'chat-telegram' ),
	},
	{
		value: 'America/Miquelon',
		label: __( 'America/Miquelon', 'chat-telegram' ),
	},
	{
		value: 'America/Moncton',
		label: __( 'America/Moncton', 'chat-telegram' ),
	},
	{
		value: 'America/Monterrey',
		label: __( 'America/Monterrey', 'chat-telegram' ),
	},
	{
		value: 'America/Montevideo',
		label: __( 'America/Montevideo', 'chat-telegram' ),
	},
	{
		value: 'America/Montreal',
		label: __( 'America/Montreal', 'chat-telegram' ),
	},
	{
		value: 'America/Montserrat',
		label: __( 'America/Montserrat', 'chat-telegram' ),
	},
	{
		value: 'America/Nassau',
		label: __( 'America/Nassau', 'chat-telegram' ),
	},
	{
		value: 'America/New_York',
		label: __( 'America/New_York', 'chat-telegram' ),
	},
	{
		value: 'America/Nipigon',
		label: __( 'America/Nipigon', 'chat-telegram' ),
	},
	{
		value: 'America/Nome',
		label: __( 'America/Nome', 'chat-telegram' ),
	},
	{
		value: 'America/Noronha',
		label: __( 'America/Noronha', 'chat-telegram' ),
	},
	{
		value: 'America/North_Dakota/Beulah',
		label: __( 'America/North_Dakota/Beulah', 'chat-telegram' ),
	},
	{
		value: 'America/North_Dakota/Center',
		label: __( 'America/North_Dakota/Center', 'chat-telegram' ),
	},
	{
		value: 'America/North_Dakota/New_Salem',
		label: __( 'America/North_Dakota/New_Salem', 'chat-telegram' ),
	},
	{
		value: 'America/Ojinaga',
		label: __( 'America/Ojinaga', 'chat-telegram' ),
	},
	{
		value: 'America/Panama',
		label: __( 'America/Panama', 'chat-telegram' ),
	},
	{
		value: 'America/Pangnirtung',
		label: __( 'America/Pangnirtung', 'chat-telegram' ),
	},
	{
		value: 'America/Paramaribo',
		label: __( 'America/Paramaribo', 'chat-telegram' ),
	},
	{
		value: 'America/Phoenix',
		label: __( 'America/Phoenix', 'chat-telegram' ),
	},
	{
		value: 'America/Port-au-Prince',
		label: __( 'America/Port-au-Prince', 'chat-telegram' ),
	},
	{
		value: 'America/Port_of_Spain',
		label: __( 'America/Port_of_Spain', 'chat-telegram' ),
	},
	{
		value: 'America/Porto_Acre',
		label: __( 'America/Porto_Acre', 'chat-telegram' ),
	},
	{
		value: 'America/Porto_Velho',
		label: __( 'America/Porto_Velho', 'chat-telegram' ),
	},
	{
		value: 'America/Puerto_Rico',
		label: __( 'America/Puerto_Rico', 'chat-telegram' ),
	},
	{
		value: 'America/Punta_Arenas',
		label: __( 'America/Punta_Arenas', 'chat-telegram' ),
	},
	{
		value: 'America/Rainy_River',
		label: __( 'America/Rainy_River', 'chat-telegram' ),
	},
	{
		value: 'America/Rankin_Inlet',
		label: __( 'America/Rankin_Inlet', 'chat-telegram' ),
	},
	{
		value: 'America/Recife',
		label: __( 'America/Recife', 'chat-telegram' ),
	},
	{
		value: 'America/Regina',
		label: __( 'America/Regina', 'chat-telegram' ),
	},
	{
		value: 'America/Resolute',
		label: __( 'America/Resolute', 'chat-telegram' ),
	},
	{
		value: 'America/Rio_Branco',
		label: __( 'America/Rio_Branco', 'chat-telegram' ),
	},
	{
		value: 'America/Rosario',
		label: __( 'America/Rosario', 'chat-telegram' ),
	},
	{
		value: 'America/Santa_Isabel',
		label: __( 'America/Santa_Isabel', 'chat-telegram' ),
	},
	{
		value: 'America/Santarem',
		label: __( 'America/Santarem', 'chat-telegram' ),
	},
	{
		value: 'America/Santiago',
		label: __( 'America/Santiago', 'chat-telegram' ),
	},
	{
		value: 'America/Santo_Domingo',
		label: __( 'America/Santo_Domingo', 'chat-telegram' ),
	},
	{
		value: 'America/Sao_Paulo',
		label: __( 'America/Sao_Paulo', 'chat-telegram' ),
	},
	{
		value: 'America/Scoresbysund',
		label: __( 'America/Scoresbysund', 'chat-telegram' ),
	},
	{
		value: 'America/Shiprock',
		label: __( 'America/Shiprock', 'chat-telegram' ),
	},
	{
		value: 'America/Sitka',
		label: __( 'America/Sitka', 'chat-telegram' ),
	},
	{
		value: 'America/St_Barthelemy',
		label: __( 'America/St_Barthelemy', 'chat-telegram' ),
	},
	{
		value: 'America/St_Johns',
		label: __( 'America/St_Johns', 'chat-telegram' ),
	},
	{
		value: 'America/St_Kitts',
		label: __( 'America/St_Kitts', 'chat-telegram' ),
	},
	{
		value: 'America/St_Lucia',
		label: __( 'America/St_Lucia', 'chat-telegram' ),
	},
	{
		value: 'America/St_Thomas',
		label: __( 'America/St_Thomas', 'chat-telegram' ),
	},
	{
		value: 'America/St_Vincent',
		label: __( 'America/St_Vincent', 'chat-telegram' ),
	},
	{
		value: 'America/Swift_Current',
		label: __( 'America/Swift_Current', 'chat-telegram' ),
	},
	{
		value: 'America/Tegucigalpa',
		label: __( 'America/Tegucigalpa', 'chat-telegram' ),
	},
	{
		value: 'America/Thule',
		label: __( 'America/Thule', 'chat-telegram' ),
	},
	{
		value: 'America/Thunder_Bay',
		label: __( 'America/Thunder_Bay', 'chat-telegram' ),
	},
	{
		value: 'America/Tijuana',
		label: __( 'America/Tijuana', 'chat-telegram' ),
	},
	{
		value: 'America/Toronto',
		label: __( 'America/Toronto', 'chat-telegram' ),
	},
	{
		value: 'America/Tortola',
		label: __( 'America/Tortola', 'chat-telegram' ),
	},
	{
		value: 'America/Vancouver',
		label: __( 'America/Vancouver', 'chat-telegram' ),
	},
	{
		value: 'America/Virgin',
		label: __( 'America/Virgin', 'chat-telegram' ),
	},
	{
		value: 'America/Whitehorse',
		label: __( 'America/Whitehorse', 'chat-telegram' ),
	},
	{
		value: 'America/Winnipeg',
		label: __( 'America/Winnipeg', 'chat-telegram' ),
	},
	{
		value: 'America/Yakutat',
		label: __( 'America/Yakutat', 'chat-telegram' ),
	},
	{
		value: 'America/Yellowknife',
		label: __( 'America/Yellowknife', 'chat-telegram' ),
	},
	{
		value: 'Antarctica/Casey',
		label: __( 'Antarctica/Casey', 'chat-telegram' ),
	},
	{
		value: 'Antarctica/Davis',
		label: __( 'Antarctica/Davis', 'chat-telegram' ),
	},
	{
		value: 'Antarctica/DumontDUrville',
		label: __( 'Antarctica/DumontDUrville', 'chat-telegram' ),
	},
	{
		value: 'Antarctica/Macquarie',
		label: __( 'Antarctica/Macquarie', 'chat-telegram' ),
	},
	{
		value: 'Antarctica/Mawson',
		label: __( 'Antarctica/Mawson', 'chat-telegram' ),
	},
	{
		value: 'Antarctica/McMurdo',
		label: __( 'Antarctica/McMurdo', 'chat-telegram' ),
	},
	{
		value: 'Antarctica/Palmer',
		label: __( 'Antarctica/Palmer', 'chat-telegram' ),
	},
	{
		value: 'Antarctica/Rothera',
		label: __( 'Antarctica/Rothera', 'chat-telegram' ),
	},
	{
		value: 'Antarctica/South_Pole',
		label: __( 'Antarctica/South_Pole', 'chat-telegram' ),
	},
	{
		value: 'Antarctica/Syowa',
		label: __( 'Antarctica/Syowa', 'chat-telegram' ),
	},
	{
		value: 'Antarctica/Troll',
		label: __( 'Antarctica/Troll', 'chat-telegram' ),
	},
	{
		value: 'Antarctica/Vostok',
		label: __( 'Antarctica/Vostok', 'chat-telegram' ),
	},
	{
		value: 'Arctic/Longyearbyen',
		label: __( 'Arctic/Longyearbyen', 'chat-telegram' ),
	},
	{
		value: 'Asia/Aden',
		label: __( 'Asia/Aden', 'chat-telegram' ),
	},
	{
		value: 'Asia/Almaty',
		label: __( 'Asia/Almaty', 'chat-telegram' ),
	},
	{
		value: 'Asia/Amman',
		label: __( 'Asia/Amman', 'chat-telegram' ),
	},
	{
		value: 'Asia/Anadyr',
		label: __( 'Asia/Anadyr', 'chat-telegram' ),
	},
	{
		value: 'Asia/Aqtau',
		label: __( 'Asia/Aqtau', 'chat-telegram' ),
	},
	{
		value: 'Asia/Aqtobe',
		label: __( 'Asia/Aqtobe', 'chat-telegram' ),
	},
	{
		value: 'Asia/Ashgabat',
		label: __( 'Asia/Ashgabat', 'chat-telegram' ),
	},
	{
		value: 'Asia/Ashkhabad',
		label: __( 'Asia/Ashkhabad', 'chat-telegram' ),
	},
	{
		value: 'Asia/Atyrau',
		label: __( 'Asia/Atyrau', 'chat-telegram' ),
	},
	{
		value: 'Asia/Baghdad',
		label: __( 'Asia/Baghdad', 'chat-telegram' ),
	},
	{
		value: 'Asia/Bahrain',
		label: __( 'Asia/Bahrain', 'chat-telegram' ),
	},
	{
		value: 'Asia/Baku',
		label: __( 'Asia/Baku', 'chat-telegram' ),
	},
	{
		value: 'Asia/Bangkok',
		label: __( 'Asia/Bangkok', 'chat-telegram' ),
	},
	{
		value: 'Asia/Barnaul',
		label: __( 'Asia/Barnaul', 'chat-telegram' ),
	},
	{
		value: 'Asia/Beirut',
		label: __( 'Asia/Beirut', 'chat-telegram' ),
	},
	{
		value: 'Asia/Bishkek',
		label: __( 'Asia/Bishkek', 'chat-telegram' ),
	},
	{
		value: 'Asia/Brunei',
		label: __( 'Asia/Brunei', 'chat-telegram' ),
	},
	{
		value: 'Asia/Calcutta',
		label: __( 'Asia/Calcutta', 'chat-telegram' ),
	},
	{
		value: 'Asia/Chita',
		label: __( 'Asia/Chita', 'chat-telegram' ),
	},
	{
		value: 'Asia/Choibalsan',
		label: __( 'Asia/Choibalsan', 'chat-telegram' ),
	},
	{
		value: 'Asia/Chongqing',
		label: __( 'Asia/Chongqing', 'chat-telegram' ),
	},
	{
		value: 'Asia/Chungking',
		label: __( 'Asia/Chungking', 'chat-telegram' ),
	},
	{
		value: 'Asia/Colombo',
		label: __( 'Asia/Colombo', 'chat-telegram' ),
	},
	{
		value: 'Asia/Dacca',
		label: __( 'Asia/Dacca', 'chat-telegram' ),
	},
	{
		value: 'Asia/Damascus',
		label: __( 'Asia/Damascus', 'chat-telegram' ),
	},
	{
		value: 'Asia/Dhaka',
		label: __( 'Asia/Dhaka', 'chat-telegram' ),
	},
	{
		value: 'Asia/Dili',
		label: __( 'Asia/Dili', 'chat-telegram' ),
	},
	{
		value: 'Asia/Dubai',
		label: __( 'Asia/Dubai', 'chat-telegram' ),
	},
	{
		value: 'Asia/Dushanbe',
		label: __( 'Asia/Dushanbe', 'chat-telegram' ),
	},
	{
		value: 'Asia/Famagusta',
		label: __( 'Asia/Famagusta', 'chat-telegram' ),
	},
	{
		value: 'Asia/Gaza',
		label: __( 'Asia/Gaza', 'chat-telegram' ),
	},
	{
		value: 'Asia/Harbin',
		label: __( 'Asia/Harbin', 'chat-telegram' ),
	},
	{
		value: 'Asia/Hebron',
		label: __( 'Asia/Hebron', 'chat-telegram' ),
	},
	{
		value: 'Asia/Ho_Chi_Minh',
		label: __( 'Asia/Ho_Chi_Minh', 'chat-telegram' ),
	},
	{
		value: 'Asia/Hong_Kong',
		label: __( 'Asia/Hong_Kong', 'chat-telegram' ),
	},
	{
		value: 'Asia/Hovd',
		label: __( 'Asia/Hovd', 'chat-telegram' ),
	},
	{
		value: 'Asia/Irkutsk',
		label: __( 'Asia/Irkutsk', 'chat-telegram' ),
	},
	{
		value: 'Asia/Istanbul',
		label: __( 'Asia/Istanbul', 'chat-telegram' ),
	},
	{
		value: 'Asia/Jakarta',
		label: __( 'Asia/Jakarta', 'chat-telegram' ),
	},
	{
		value: 'Asia/Jayapura',
		label: __( 'Asia/Jayapura', 'chat-telegram' ),
	},
	{
		value: 'Asia/Jerusalem',
		label: __( 'Asia/Jerusalem', 'chat-telegram' ),
	},
	{
		value: 'Asia/Kabul',
		label: __( 'Asia/Kabul', 'chat-telegram' ),
	},
	{
		value: 'Asia/Kamchatka',
		label: __( 'Asia/Kamchatka', 'chat-telegram' ),
	},
	{
		value: 'Asia/Karachi',
		label: __( 'Asia/Karachi', 'chat-telegram' ),
	},
	{
		value: 'Asia/Kashgar',
		label: __( 'Asia/Kashgar', 'chat-telegram' ),
	},
	{
		value: 'Asia/Kathmandu',
		label: __( 'Asia/Kathmandu', 'chat-telegram' ),
	},
	{
		value: 'Asia/Katmandu',
		label: __( 'Asia/Katmandu', 'chat-telegram' ),
	},
	{
		value: 'Asia/Khandyga',
		label: __( 'Asia/Khandyga', 'chat-telegram' ),
	},
	{
		value: 'Asia/Kolkata',
		label: __( 'Asia/Kolkata', 'chat-telegram' ),
	},
	{
		value: 'Asia/Krasnoyarsk',
		label: __( 'Asia/Krasnoyarsk', 'chat-telegram' ),
	},
	{
		value: 'Asia/Kuala_Lumpur',
		label: __( 'Asia/Kuala_Lumpur', 'chat-telegram' ),
	},
	{
		value: 'Asia/Kuching',
		label: __( 'Asia/Kuching', 'chat-telegram' ),
	},
	{
		value: 'Asia/Kuwait',
		label: __( 'Asia/Kuwait', 'chat-telegram' ),
	},
	{
		value: 'Asia/Macao',
		label: __( 'Asia/Macao', 'chat-telegram' ),
	},
	{
		value: 'Asia/Macau',
		label: __( 'Asia/Macau', 'chat-telegram' ),
	},
	{
		value: 'Asia/Magadan',
		label: __( 'Asia/Magadan', 'chat-telegram' ),
	},
	{
		value: 'Asia/Makassar',
		label: __( 'Asia/Makassar', 'chat-telegram' ),
	},
	{
		value: 'Asia/Manila',
		label: __( 'Asia/Manila', 'chat-telegram' ),
	},
	{
		value: 'Asia/Muscat',
		label: __( 'Asia/Muscat', 'chat-telegram' ),
	},
	{
		value: 'Asia/Nicosia',
		label: __( 'Asia/Nicosia', 'chat-telegram' ),
	},
	{
		value: 'Asia/Novokuznetsk',
		label: __( 'Asia/Novokuznetsk', 'chat-telegram' ),
	},
	{
		value: 'Asia/Novosibirsk',
		label: __( 'Asia/Novosibirsk', 'chat-telegram' ),
	},
	{
		value: 'Asia/Omsk',
		label: __( 'Asia/Omsk', 'chat-telegram' ),
	},
	{
		value: 'Asia/Oral',
		label: __( 'Asia/Oral', 'chat-telegram' ),
	},
	{
		value: 'Asia/Phnom_Penh',
		label: __( 'Asia/Phnom_Penh', 'chat-telegram' ),
	},
	{
		value: 'Asia/Pontianak',
		label: __( 'Asia/Pontianak', 'chat-telegram' ),
	},
	{
		value: 'Asia/Pyongyang',
		label: __( 'Asia/Pyongyang', 'chat-telegram' ),
	},
	{
		value: 'Asia/Qatar',
		label: __( 'Asia/Qatar', 'chat-telegram' ),
	},
	{
		value: 'Asia/Qyzylorda',
		label: __( 'Asia/Qyzylorda', 'chat-telegram' ),
	},
	{
		value: 'Asia/Rangoon',
		label: __( 'Asia/Rangoon', 'chat-telegram' ),
	},
	{
		value: 'Asia/Riyadh',
		label: __( 'Asia/Riyadh', 'chat-telegram' ),
	},
	{
		value: 'Asia/Saigon',
		label: __( 'Asia/Saigon', 'chat-telegram' ),
	},
	{
		value: 'Asia/Sakhalin',
		label: __( 'Asia/Sakhalin', 'chat-telegram' ),
	},
	{
		value: 'Asia/Samarkand',
		label: __( 'Asia/Samarkand', 'chat-telegram' ),
	},
	{
		value: 'Asia/Seoul',
		label: __( 'Asia/Seoul', 'chat-telegram' ),
	},
	{
		value: 'Asia/Shanghai',
		label: __( 'Asia/Shanghai', 'chat-telegram' ),
	},
	{
		value: 'Asia/Singapore',
		label: __( 'Asia/Singapore', 'chat-telegram' ),
	},
	{
		value: 'Asia/Srednekolymsk',
		label: __( 'Asia/Srednekolymsk', 'chat-telegram' ),
	},
	{
		value: 'Asia/Taipei',
		label: __( 'Asia/Taipei', 'chat-telegram' ),
	},
	{
		value: 'Asia/Tashkent',
		label: __( 'Asia/Tashkent', 'chat-telegram' ),
	},
	{
		value: 'Asia/Tbilisi',
		label: __( 'Asia/Tbilisi', 'chat-telegram' ),
	},
	{
		value: 'Asia/Tehran',
		label: __( 'Asia/Tehran', 'chat-telegram' ),
	},
	{
		value: 'Asia/Tel_Aviv',
		label: __( 'Asia/Tel_Aviv', 'chat-telegram' ),
	},
	{
		value: 'Asia/Thimbu',
		label: __( 'Asia/Thimbu', 'chat-telegram' ),
	},
	{
		value: 'Asia/Thimphu',
		label: __( 'Asia/Thimphu', 'chat-telegram' ),
	},
	{
		value: 'Asia/Tokyo',
		label: __( 'Asia/Tokyo', 'chat-telegram' ),
	},
	{
		value: 'Asia/Tomsk',
		label: __( 'Asia/Tomsk', 'chat-telegram' ),
	},
	{
		value: 'Asia/Ujung_Pandang',
		label: __( 'Asia/Ujung_Pandang', 'chat-telegram' ),
	},
	{
		value: 'Asia/Ulaanbaatar',
		label: __( 'Asia/Ulaanbaatar', 'chat-telegram' ),
	},
	{
		value: 'Asia/Ulan_Bator',
		label: __( 'Asia/Ulan_Bator', 'chat-telegram' ),
	},
	{
		value: 'Asia/Urumqi',
		label: __( 'Asia/Urumqi', 'chat-telegram' ),
	},
	{
		value: 'Asia/Ust-Nera',
		label: __( 'Asia/Ust-Nera', 'chat-telegram' ),
	},
	{
		value: 'Asia/Vientiane',
		label: __( 'Asia/Vientiane', 'chat-telegram' ),
	},
	{
		value: 'Asia/Vladivostok',
		label: __( 'Asia/Vladivostok', 'chat-telegram' ),
	},
	{
		value: 'Asia/Yakutsk',
		label: __( 'Asia/Yakutsk', 'chat-telegram' ),
	},
	{
		value: 'Asia/Yangon',
		label: __( 'Asia/Yangon', 'chat-telegram' ),
	},
	{
		value: 'Asia/Yekaterinburg',
		label: __( 'Asia/Yekaterinburg', 'chat-telegram' ),
	},
	{
		value: 'Asia/Yerevan',
		label: __( 'Asia/Yerevan', 'chat-telegram' ),
	},
	{
		value: 'Atlantic/Azores',
		label: __( 'Atlantic/Azores', 'chat-telegram' ),
	},
	{
		value: 'Atlantic/Bermuda',
		label: __( 'Atlantic/Bermuda', 'chat-telegram' ),
	},
	{
		value: 'Atlantic/Canary',
		label: __( 'Atlantic/Canary', 'chat-telegram' ),
	},
	{
		value: 'Atlantic/Cape_Verde',
		label: __( 'Atlantic/Cape_Verde', 'chat-telegram' ),
	},
	{
		value: 'Atlantic/Faeroe',
		label: __( 'Atlantic/Faeroe', 'chat-telegram' ),
	},
	{
		value: 'Atlantic/Faroe',
		label: __( 'Atlantic/Faroe', 'chat-telegram' ),
	},
	{
		value: 'Atlantic/Jan_Mayen',
		label: __( 'Atlantic/Jan_Mayen', 'chat-telegram' ),
	},
	{
		value: 'Atlantic/Madeira',
		label: __( 'Atlantic/Madeira', 'chat-telegram' ),
	},
	{
		value: 'Atlantic/Reykjavik',
		label: __( 'Atlantic/Reykjavik', 'chat-telegram' ),
	},
	{
		value: 'Atlantic/South_Georgia',
		label: __( 'Atlantic/South_Georgia', 'chat-telegram' ),
	},
	{
		value: 'Atlantic/St_Helena',
		label: __( 'Atlantic/St_Helena', 'chat-telegram' ),
	},
	{
		value: 'Atlantic/Stanley',
		label: __( 'Atlantic/Stanley', 'chat-telegram' ),
	},
	{
		value: 'Australia/ACT',
		label: __( 'Australia/ACT', 'chat-telegram' ),
	},
	{
		value: 'Australia/Adelaide',
		label: __( 'Australia/Adelaide', 'chat-telegram' ),
	},
	{
		value: 'Australia/Brisbane',
		label: __( 'Australia/Brisbane', 'chat-telegram' ),
	},
	{
		value: 'Australia/Broken_Hill',
		label: __( 'Australia/Broken_Hill', 'chat-telegram' ),
	},
	{
		value: 'Australia/Canberra',
		label: __( 'Australia/Canberra', 'chat-telegram' ),
	},
	{
		value: 'Australia/Currie',
		label: __( 'Australia/Currie', 'chat-telegram' ),
	},
	{
		value: 'Australia/Darwin',
		label: __( 'Australia/Darwin', 'chat-telegram' ),
	},
	{
		value: 'Australia/Eucla',
		label: __( 'Australia/Eucla', 'chat-telegram' ),
	},
	{
		value: 'Australia/Hobart',
		label: __( 'Australia/Hobart', 'chat-telegram' ),
	},
	{
		value: 'Australia/LHI',
		label: __( 'Australia/LHI', 'chat-telegram' ),
	},
	{
		value: 'Australia/Lindeman',
		label: __( 'Australia/Lindeman', 'chat-telegram' ),
	},
	{
		value: 'Australia/Lord_Howe',
		label: __( 'Australia/Lord_Howe', 'chat-telegram' ),
	},
	{
		value: 'Australia/Melbourne',
		label: __( 'Australia/Melbourne', 'chat-telegram' ),
	},
	{
		value: 'Australia/NSW',
		label: __( 'Australia/NSW', 'chat-telegram' ),
	},
	{
		value: 'Australia/North',
		label: __( 'Australia/North', 'chat-telegram' ),
	},
	{
		value: 'Australia/Perth',
		label: __( 'Australia/Perth', 'chat-telegram' ),
	},
	{
		value: 'Australia/Queensland',
		label: __( 'Australia/Queensland', 'chat-telegram' ),
	},
	{
		value: 'Australia/South',
		label: __( 'Australia/South', 'chat-telegram' ),
	},
	{
		value: 'Australia/Sydney',
		label: __( 'Australia/Sydney', 'chat-telegram' ),
	},
	{
		value: 'Australia/Tasmania',
		label: __( 'Australia/Tasmania', 'chat-telegram' ),
	},
	{
		value: 'Australia/Victoria',
		label: __( 'Australia/Victoria', 'chat-telegram' ),
	},
	{
		value: 'Australia/West',
		label: __( 'Australia/West', 'chat-telegram' ),
	},
	{
		value: 'Australia/Yancowinna',
		label: __( 'Australia/Yancowinna', 'chat-telegram' ),
	},
	{
		value: 'Brazil/Acre',
		label: __( 'Brazil/Acre', 'chat-telegram' ),
	},
	{
		value: 'Brazil/DeNoronha',
		label: __( 'Brazil/DeNoronha', 'chat-telegram' ),
	},
	{
		value: 'Brazil/East',
		label: __( 'Brazil/East', 'chat-telegram' ),
	},
	{
		value: 'Brazil/West',
		label: __( 'Brazil/West', 'chat-telegram' ),
	},
	{
		value: 'CET',
		label: __( 'CET', 'chat-telegram' ),
	},
	{
		value: 'CST6CDT',
		label: __( 'CST6CDT', 'chat-telegram' ),
	},
	{
		value: 'Canada/Atlantic',
		label: __( 'Canada/Atlantic', 'chat-telegram' ),
	},
	{
		value: 'Canada/Central',
		label: __( 'Canada/Central', 'chat-telegram' ),
	},
	{
		value: 'Canada/Eastern',
		label: __( 'Canada/Eastern', 'chat-telegram' ),
	},
	{
		value: 'Canada/Mountain',
		label: __( 'Canada/Mountain', 'chat-telegram' ),
	},
	{
		value: 'Canada/Newfoundland',
		label: __( 'Canada/Newfoundland', 'chat-telegram' ),
	},
	{
		value: 'Canada/Pacific',
		label: __( 'Canada/Pacific', 'chat-telegram' ),
	},
	{
		value: 'Canada/Saskatchewan',
		label: __( 'Canada/Saskatchewan', 'chat-telegram' ),
	},
	{
		value: 'Canada/Yukon',
		label: __( 'Canada/Yukon', 'chat-telegram' ),
	},
	{
		value: 'Chile/Continental',
		label: __( 'Chile/Continental', 'chat-telegram' ),
	},
	{
		value: 'Chile/EasterIsland',
		label: __( 'Chile/EasterIsland', 'chat-telegram' ),
	},
	{
		value: 'Cuba',
		label: __( 'Cuba', 'chat-telegram' ),
	},
	{
		value: 'EET',
		label: __( 'EET', 'chat-telegram' ),
	},
	{
		value: 'EST',
		label: __( 'EST', 'chat-telegram' ),
	},
	{
		value: 'EST5EDT',
		label: __( 'EST5EDT', 'chat-telegram' ),
	},
	{
		value: 'Egypt',
		label: __( 'Egypt', 'chat-telegram' ),
	},
	{
		value: 'Eire',
		label: __( 'Eire', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT',
		label: __( 'Etc/GMT', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT+0',
		label: __( 'Etc/GMT+0', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT+1',
		label: __( 'Etc/GMT+1', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT+10',
		label: __( 'Etc/GMT+10', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT+11',
		label: __( 'Etc/GMT+11', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT+12',
		label: __( 'Etc/GMT+12', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT+2',
		label: __( 'Etc/GMT+2', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT+3',
		label: __( 'Etc/GMT+3', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT+4',
		label: __( 'Etc/GMT+4', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT+5',
		label: __( 'Etc/GMT+5', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT+6',
		label: __( 'Etc/GMT+6', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT+7',
		label: __( 'Etc/GMT+7', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT+8',
		label: __( 'Etc/GMT+8', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT+9',
		label: __( 'Etc/GMT+9', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT-0',
		label: __( 'Etc/GMT-0', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT-1',
		label: __( 'Etc/GMT-1', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT-10',
		label: __( 'Etc/GMT-10', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT-11',
		label: __( 'Etc/GMT-11', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT-12',
		label: __( 'Etc/GMT-12', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT-13',
		label: __( 'Etc/GMT-13', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT-14',
		label: __( 'Etc/GMT-14', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT-2',
		label: __( 'Etc/GMT-2', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT-3',
		label: __( 'Etc/GMT-3', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT-4',
		label: __( 'Etc/GMT-4', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT-5',
		label: __( 'Etc/GMT-5', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT-6',
		label: __( 'Etc/GMT-6', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT-7',
		label: __( 'Etc/GMT-7', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT-8',
		label: __( 'Etc/GMT-8', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT-9',
		label: __( 'Etc/GMT-9', 'chat-telegram' ),
	},
	{
		value: 'Etc/GMT0',
		label: __( 'Etc/GMT0', 'chat-telegram' ),
	},
	{
		value: 'Etc/Greenwich',
		label: __( 'Etc/Greenwich', 'chat-telegram' ),
	},
	{
		value: 'Etc/UCT',
		label: __( 'Etc/UCT', 'chat-telegram' ),
	},
	{
		value: 'Etc/UTC',
		label: __( 'Etc/UTC', 'chat-telegram' ),
	},
	{
		value: 'Etc/Universal',
		label: __( 'Etc/Universal', 'chat-telegram' ),
	},
	{
		value: 'Etc/Zulu',
		label: __( 'Etc/Zulu', 'chat-telegram' ),
	},
	{
		value: 'Europe/Amsterdam',
		label: __( 'Europe/Amsterdam', 'chat-telegram' ),
	},
	{
		value: 'Europe/Andorra',
		label: __( 'Europe/Andorra', 'chat-telegram' ),
	},
	{
		value: 'Europe/Astrakhan',
		label: __( 'Europe/Astrakhan', 'chat-telegram' ),
	},
	{
		value: 'Europe/Athens',
		label: __( 'Europe/Athens', 'chat-telegram' ),
	},
	{
		value: 'Europe/Belfast',
		label: __( 'Europe/Belfast', 'chat-telegram' ),
	},
	{
		value: 'Europe/Belgrade',
		label: __( 'Europe/Belgrade', 'chat-telegram' ),
	},
	{
		value: 'Europe/Berlin',
		label: __( 'Europe/Berlin', 'chat-telegram' ),
	},
	{
		value: 'Europe/Bratislava',
		label: __( 'Europe/Bratislava', 'chat-telegram' ),
	},
	{
		value: 'Europe/Brussels',
		label: __( 'Europe/Brussels', 'chat-telegram' ),
	},
	{
		value: 'Europe/Bucharest',
		label: __( 'Europe/Bucharest', 'chat-telegram' ),
	},
	{
		value: 'Europe/Budapest',
		label: __( 'Europe/Budapest', 'chat-telegram' ),
	},
	{
		value: 'Europe/Busingen',
		label: __( 'Europe/Busingen', 'chat-telegram' ),
	},
	{
		value: 'Europe/Chisinau',
		label: __( 'Europe/Chisinau', 'chat-telegram' ),
	},
	{
		value: 'Europe/Copenhagen',
		label: __( 'Europe/Copenhagen', 'chat-telegram' ),
	},
	{
		value: 'Europe/Dublin',
		label: __( 'Europe/Dublin', 'chat-telegram' ),
	},
	{
		value: 'Europe/Gibraltar',
		label: __( 'Europe/Gibraltar', 'chat-telegram' ),
	},
	{
		value: 'Europe/Guernsey',
		label: __( 'Europe/Guernsey', 'chat-telegram' ),
	},
	{
		value: 'Europe/Helsinki',
		label: __( 'Europe/Helsinki', 'chat-telegram' ),
	},
	{
		value: 'Europe/Isle_of_Man',
		label: __( 'Europe/Isle_of_Man', 'chat-telegram' ),
	},
	{
		value: 'Europe/Istanbul',
		label: __( 'Europe/Istanbul', 'chat-telegram' ),
	},
	{
		value: 'Europe/Jersey',
		label: __( 'Europe/Jersey', 'chat-telegram' ),
	},
	{
		value: 'Europe/Kaliningrad',
		label: __( 'Europe/Kaliningrad', 'chat-telegram' ),
	},
	{
		value: 'Europe/Kiev',
		label: __( 'Europe/Kiev', 'chat-telegram' ),
	},
	{
		value: 'Europe/Kirov',
		label: __( 'Europe/Kirov', 'chat-telegram' ),
	},
	{
		value: 'Europe/Lisbon',
		label: __( 'Europe/Lisbon', 'chat-telegram' ),
	},
	{
		value: 'Europe/Ljubljana',
		label: __( 'Europe/Ljubljana', 'chat-telegram' ),
	},
	{
		value: 'Europe/London',
		label: __( 'Europe/London', 'chat-telegram' ),
	},
	{
		value: 'Europe/Luxembourg',
		label: __( 'Europe/Luxembourg', 'chat-telegram' ),
	},
	{
		value: 'Europe/Madrid',
		label: __( 'Europe/Madrid', 'chat-telegram' ),
	},
	{
		value: 'Europe/Malta',
		label: __( 'Europe/Malta', 'chat-telegram' ),
	},
	{
		value: 'Europe/Mariehamn',
		label: __( 'Europe/Mariehamn', 'chat-telegram' ),
	},
	{
		value: 'Europe/Minsk',
		label: __( 'Europe/Minsk', 'chat-telegram' ),
	},
	{
		value: 'Europe/Monaco',
		label: __( 'Europe/Monaco', 'chat-telegram' ),
	},
	{
		value: 'Europe/Moscow',
		label: __( 'Europe/Moscow', 'chat-telegram' ),
	},
	{
		value: 'Europe/Nicosia',
		label: __( 'Europe/Nicosia', 'chat-telegram' ),
	},
	{
		value: 'Europe/Oslo',
		label: __( 'Europe/Oslo', 'chat-telegram' ),
	},
	{
		value: 'Europe/Paris',
		label: __( 'Europe/Paris', 'chat-telegram' ),
	},
	{
		value: 'Europe/Podgorica',
		label: __( 'Europe/Podgorica', 'chat-telegram' ),
	},
	{
		value: 'Europe/Prague',
		label: __( 'Europe/Prague', 'chat-telegram' ),
	},
	{
		value: 'Europe/Riga',
		label: __( 'Europe/Riga', 'chat-telegram' ),
	},
	{
		value: 'Europe/Rome',
		label: __( 'Europe/Rome', 'chat-telegram' ),
	},
	{
		value: 'Europe/Samara',
		label: __( 'Europe/Samara', 'chat-telegram' ),
	},
	{
		value: 'Europe/San_Marino',
		label: __( 'Europe/San_Marino', 'chat-telegram' ),
	},
	{
		value: 'Europe/Sarajevo',
		label: __( 'Europe/Sarajevo', 'chat-telegram' ),
	},
	{
		value: 'Europe/Saratov',
		label: __( 'Europe/Saratov', 'chat-telegram' ),
	},
	{
		value: 'Europe/Simferopol',
		label: __( 'Europe/Simferopol', 'chat-telegram' ),
	},
	{
		value: 'Europe/Skopje',
		label: __( 'Europe/Skopje', 'chat-telegram' ),
	},
	{
		value: 'Europe/Sofia',
		label: __( 'Europe/Sofia', 'chat-telegram' ),
	},
	{
		value: 'Europe/Stockholm',
		label: __( 'Europe/Stockholm', 'chat-telegram' ),
	},
	{
		value: 'Europe/Tallinn',
		label: __( 'Europe/Tallinn', 'chat-telegram' ),
	},
	{
		value: 'Europe/Tirane',
		label: __( 'Europe/Tirane', 'chat-telegram' ),
	},
	{
		value: 'Europe/Tiraspol',
		label: __( 'Europe/Tiraspol', 'chat-telegram' ),
	},
	{
		value: 'Europe/Ulyanovsk',
		label: __( 'Europe/Ulyanovsk', 'chat-telegram' ),
	},
	{
		value: 'Europe/Uzhgorod',
		label: __( 'Europe/Uzhgorod', 'chat-telegram' ),
	},
	{
		value: 'Europe/Vaduz',
		label: __( 'Europe/Vaduz', 'chat-telegram' ),
	},
	{
		value: 'Europe/Vatican',
		label: __( 'Europe/Vatican', 'chat-telegram' ),
	},
	{
		value: 'Europe/Vienna',
		label: __( 'Europe/Vienna', 'chat-telegram' ),
	},
	{
		value: 'Europe/Vilnius',
		label: __( 'Europe/Vilnius', 'chat-telegram' ),
	},
	{
		value: 'Europe/Volgograd',
		label: __( 'Europe/Volgograd', 'chat-telegram' ),
	},
	{
		value: 'Europe/Warsaw',
		label: __( 'Europe/Warsaw', 'chat-telegram' ),
	},
	{
		value: 'Europe/Zagreb',
		label: __( 'Europe/Zagreb', 'chat-telegram' ),
	},
	{
		value: 'Europe/Zaporozhye',
		label: __( 'Europe/Zaporozhye', 'chat-telegram' ),
	},
	{
		value: 'Europe/Zurich',
		label: __( 'Europe/Zurich', 'chat-telegram' ),
	},
	{
		value: 'GB',
		label: __( 'GB', 'chat-telegram' ),
	},
	{
		value: 'GB-Eire',
		label: __( 'GB-Eire', 'chat-telegram' ),
	},
	{
		value: 'GMT',
		label: __( 'GMT', 'chat-telegram' ),
	},
	{
		value: 'GMT+0',
		label: __( 'GMT+0', 'chat-telegram' ),
	},
	{
		value: 'GMT-0',
		label: __( 'GMT-0', 'chat-telegram' ),
	},
	{
		value: 'GMT0',
		label: __( 'GMT0', 'chat-telegram' ),
	},
	{
		value: 'Greenwich',
		label: __( 'Greenwich', 'chat-telegram' ),
	},
	{
		value: 'HST',
		label: __( 'HST', 'chat-telegram' ),
	},
	{
		value: 'Hongkong',
		label: __( 'Hongkong', 'chat-telegram' ),
	},
	{
		value: 'Iceland',
		label: __( 'Iceland', 'chat-telegram' ),
	},
	{
		value: 'Indian/Antananarivo',
		label: __( 'Indian/Antananarivo', 'chat-telegram' ),
	},
	{
		value: 'Indian/Chagos',
		label: __( 'Indian/Chagos', 'chat-telegram' ),
	},
	{
		value: 'Indian/Christmas',
		label: __( 'Indian/Christmas', 'chat-telegram' ),
	},
	{
		value: 'Indian/Cocos',
		label: __( 'Indian/Cocos', 'chat-telegram' ),
	},
	{
		value: 'Indian/Comoro',
		label: __( 'Indian/Comoro', 'chat-telegram' ),
	},
	{
		value: 'Indian/Kerguelen',
		label: __( 'Indian/Kerguelen', 'chat-telegram' ),
	},
	{
		value: 'Indian/Mahe',
		label: __( 'Indian/Mahe', 'chat-telegram' ),
	},
	{
		value: 'Indian/Maldives',
		label: __( 'Indian/Maldives', 'chat-telegram' ),
	},
	{
		value: 'Indian/Mauritius',
		label: __( 'Indian/Mauritius', 'chat-telegram' ),
	},
	{
		value: 'Indian/Mayotte',
		label: __( 'Indian/Mayotte', 'chat-telegram' ),
	},
	{
		value: 'Indian/Reunion',
		label: __( 'Indian/Reunion', 'chat-telegram' ),
	},
	{
		value: 'Iran',
		label: __( 'Iran', 'chat-telegram' ),
	},
	{
		value: 'Israel',
		label: __( 'Israel', 'chat-telegram' ),
	},
	{
		value: 'Jamaica',
		label: __( 'Jamaica', 'chat-telegram' ),
	},
	{
		value: 'Japan',
		label: __( 'Japan', 'chat-telegram' ),
	},
	{
		value: 'Kwajalein',
		label: __( 'Kwajalein', 'chat-telegram' ),
	},
	{
		value: 'Libya',
		label: __( 'Libya', 'chat-telegram' ),
	},
	{
		value: 'MET',
		label: __( 'MET', 'chat-telegram' ),
	},
	{
		value: 'MST',
		label: __( 'MST', 'chat-telegram' ),
	},
	{
		value: 'MST7MDT',
		label: __( 'MST7MDT', 'chat-telegram' ),
	},
	{
		value: 'Mexico/BajaNorte',
		label: __( 'Mexico/BajaNorte', 'chat-telegram' ),
	},
	{
		value: 'Mexico/BajaSur',
		label: __( 'Mexico/BajaSur', 'chat-telegram' ),
	},
	{
		value: 'Mexico/General',
		label: __( 'Mexico/General', 'chat-telegram' ),
	},
	{
		value: 'NZ',
		label: __( 'NZ', 'chat-telegram' ),
	},
	{
		value: 'NZ-CHAT',
		label: __( 'NZ-CHAT', 'chat-telegram' ),
	},
	{
		value: 'Navajo',
		label: __( 'Navajo', 'chat-telegram' ),
	},
	{
		value: 'PRC',
		label: __( 'PRC', 'chat-telegram' ),
	},
	{
		value: 'PST8PDT',
		label: __( 'PST8PDT', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Apia',
		label: __( 'Pacific/Apia', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Auckland',
		label: __( 'Pacific/Auckland', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Bougainville',
		label: __( 'Pacific/Bougainville', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Chatham',
		label: __( 'Pacific/Chatham', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Chuuk',
		label: __( 'Pacific/Chuuk', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Easter',
		label: __( 'Pacific/Easter', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Efate',
		label: __( 'Pacific/Efate', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Enderbury',
		label: __( 'Pacific/Enderbury', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Fakaofo',
		label: __( 'Pacific/Fakaofo', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Fiji',
		label: __( 'Pacific/Fiji', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Funafuti',
		label: __( 'Pacific/Funafuti', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Galapagos',
		label: __( 'Pacific/Galapagos', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Gambier',
		label: __( 'Pacific/Gambier', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Guadalcanal',
		label: __( 'Pacific/Guadalcanal', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Guam',
		label: __( 'Pacific/Guam', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Honolulu',
		label: __( 'Pacific/Honolulu', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Johnston',
		label: __( 'Pacific/Johnston', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Kiritimati',
		label: __( 'Pacific/Kiritimati', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Kosrae',
		label: __( 'Pacific/Kosrae', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Kwajalein',
		label: __( 'Pacific/Kwajalein', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Majuro',
		label: __( 'Pacific/Majuro', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Marquesas',
		label: __( 'Pacific/Marquesas', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Midway',
		label: __( 'Pacific/Midway', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Nauru',
		label: __( 'Pacific/Nauru', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Niue',
		label: __( 'Pacific/Niue', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Norfolk',
		label: __( 'Pacific/Norfolk', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Noumea',
		label: __( 'Pacific/Noumea', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Pago_Pago',
		label: __( 'Pacific/Pago_Pago', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Palau',
		label: __( 'Pacific/Palau', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Pitcairn',
		label: __( 'Pacific/Pitcairn', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Pohnpei',
		label: __( 'Pacific/Pohnpei', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Ponape',
		label: __( 'Pacific/Ponape', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Port_Moresby',
		label: __( 'Pacific/Port_Moresby', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Rarotonga',
		label: __( 'Pacific/Rarotonga', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Saipan',
		label: __( 'Pacific/Saipan', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Samoa',
		label: __( 'Pacific/Samoa', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Tahiti',
		label: __( 'Pacific/Tahiti', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Tarawa',
		label: __( 'Pacific/Tarawa', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Tongatapu',
		label: __( 'Pacific/Tongatapu', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Truk',
		label: __( 'Pacific/Truk', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Wake',
		label: __( 'Pacific/Wake', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Wallis',
		label: __( 'Pacific/Wallis', 'chat-telegram' ),
	},
	{
		value: 'Pacific/Yap',
		label: __( 'Pacific/Yap', 'chat-telegram' ),
	},
	{
		value: 'Poland',
		label: __( 'Poland', 'chat-telegram' ),
	},
	{
		value: 'Portugal',
		label: __( 'Portugal', 'chat-telegram' ),
	},
	{
		value: 'ROC',
		label: __( 'ROC', 'chat-telegram' ),
	},
	{
		value: 'ROK',
		label: __( 'ROK', 'chat-telegram' ),
	},
	{
		value: 'Singapore',
		label: __( 'Singapore', 'chat-telegram' ),
	},
	{
		value: 'Turkey',
		label: __( 'Turkey', 'chat-telegram' ),
	},
	{
		value: 'UCT',
		label: __( 'UCT', 'chat-telegram' ),
	},
	{
		value: 'US/Alaska',
		label: __( 'US/Alaska', 'chat-telegram' ),
	},
	{
		value: 'US/Aleutian',
		label: __( 'US/Aleutian', 'chat-telegram' ),
	},
	{
		value: 'US/Arizona',
		label: __( 'US/Arizona', 'chat-telegram' ),
	},
	{
		value: 'US/Central',
		label: __( 'US/Central', 'chat-telegram' ),
	},
	{
		value: 'US/East-Indiana',
		label: __( 'US/East-Indiana', 'chat-telegram' ),
	},
	{
		value: 'US/Eastern',
		label: __( 'US/Eastern', 'chat-telegram' ),
	},
	{
		value: 'US/Hawaii',
		label: __( 'US/Hawaii', 'chat-telegram' ),
	},
	{
		value: 'US/Indiana-Starke',
		label: __( 'US/Indiana-Starke', 'chat-telegram' ),
	},
	{
		value: 'US/Michigan',
		label: __( 'US/Michigan', 'chat-telegram' ),
	},
	{
		value: 'US/Mountain',
		label: __( 'US/Mountain', 'chat-telegram' ),
	},
	{
		value: 'US/Pacific',
		label: __( 'US/Pacific', 'chat-telegram' ),
	},
	{
		value: 'US/Pacific-New',
		label: __( 'US/Pacific-New', 'chat-telegram' ),
	},
	{
		value: 'US/Samoa',
		label: __( 'US/Samoa', 'chat-telegram' ),
	},
	{
		value: 'UTC',
		label: __( 'UTC', 'chat-telegram' ),
	},
	{
		value: 'Universal',
		label: __( 'Universal', 'chat-telegram' ),
	},
	{
		value: 'W-SU',
		label: __( 'W-SU', 'chat-telegram' ),
	},
	{
		value: 'WET',
		label: __( 'WET', 'chat-telegram' ),
	},
	{
		value: 'Zulu',
		label: __( 'Zulu', 'chat-telegram' ),
	},
];

export default function Edit( props ) {
	const { attributes, setAttributes } = props;

	const {
		buttonSize,
		buttonType,
		borderRadius,
		text,
		info,
		title,
		online,
		offline,
		textAlignment,
		iconTarget,
		visibility,
		buttonLinkTarget,
		numberInput,
		imageUrl,
		timeZone,
		mondayStart,
		mondayEnd,
		tuesdayStart,
		tuesdayEnd,
		wednesdayStart,
		wednesdayEnd,
		thursdayStart,
		thursdayEnd,
		fridayStart,
		fridayEnd,
		saturdayStart,
		saturdayEnd,
		sundayStart,
		sundayEnd,
	} = attributes;

	const [ filteredOptions, setFilteredOptions ] = useState( timezones );

	function onInputChange( value ) {
		setFilteredOptions(
			timezones.filter( ( timezone ) =>
				timezone.label.toLowerCase().includes( value.toLowerCase() )
			)
		);
	}

	function onFontSizeChange( value ) {
		setAttributes( { timeZone: value } );
	}
	const onSelectImage = ( image ) => {
		setAttributes( {
			imageUrl: image.url,
		} );
	};
	const onChangeAlignment = ( newAlignment ) => {
		setAttributes( { textAlignment: newAlignment } );
	};
	const onChangeText = ( newText ) => {
		setAttributes( { text: newText } );
	};
	const advancedBtnInfo = ( newInfo ) => {
		setAttributes( { info: newInfo } );
	};
	const advancedBtnTitle = ( newTitle ) => {
		setAttributes( { title: newTitle } );
	};
	const advancedBtnOnlineBadge = ( newOnline ) => {
		setAttributes( { online: newOnline } );
	};
	const onIconTarget = ( onIconTargets ) => {
		setAttributes( { iconTarget: onIconTargets } );
	};
	const onButtonLinkTarget = ( newLinkTarget ) => {
		setAttributes( { buttonLinkTarget: newLinkTarget } );
	};

	const textClasses = classnames( `teleSupportButtons-align-${ textAlignment }` );

	const basicBtn = classnames( `teleSupport-button-4 tg-btn-bg` );
	const classes = classnames( `teleSupportButtons teleSupport-button-4 tg-btn-bg` );

	const buttonSizeOptions = [
		{ value: 'size-small', label: __( 'Small', 'chat-telegram' ) },
		{ value: 'size-medium', label: __( 'Medium', 'chat-telegram' ) },
		{ value: 'size-large', label: __( 'Large', 'chat-telegram' ) },
	];
	const buttonTypeOptions = [
		{ value: 'basic-button', label: __( 'Basic Button', 'chat-telegram' ) },
		{
			value: 'advance-button',
			label: __( 'Advance Button', 'chat-telegram' ),
		},
	];
	const borderRadiusOptions = [
		{
			value: 'border-squared',
			label: __( 'Border Squared', 'chat-telegram' ),
		},
		{
			value: 'border-rounded',
			label: __( 'Border Rounded', 'chat-telegram' ),
		},
	];
	const visibilityOn = [
		{ value: '', label: __( 'Everywhere', 'chat-telegram' ) },
		{
			value: 'teleSupport-desktop-only',
			label: __( 'Desktop only', 'chat-telegram' ),
		},
		{
			value: 'teleSupport-tablet-only',
			label: __( 'Tablets only', 'chat-telegram' ),
		},
		{
			value: 'teleSupport-mobile-tablet-only',
			label: __( 'Mobile and tablets', 'chat-telegram' ),
		},
		{
			value: 'teleSupport-mobile-only',
			label: __( 'Mobile only', 'chat-telegram' ),
		},
	];

	return (
		<>
			<InspectorControls>
				<PanelBody>
					<SelectControl
						label={ __( 'Button Type', 'chat-telegram' ) }
						value={ buttonType }
						options={ buttonTypeOptions.map(
							( { value, label } ) => ( {
								value,
								label,
							} )
						) }
						onChange={ ( newButton ) => {
							setAttributes( { buttonType: newButton } );
						} }
					/>
				</PanelBody>
			</InspectorControls>
			{ buttonType === 'basic-button' ? (
				<>
					<InspectorControls>
						<PanelBody
							title={ __( 'Telegram Link', 'chat-telegram' ) }
							initialOpen={ false }
						>
							<TextControl
								label={ __( 'Chanel Link Name', 'chat-telegram' ) }
								value={ numberInput }
								onChange={ ( val ) =>
									setAttributes( { numberInput: val } )
								}
								help={ __(
									'Add your telegram chanel link name',
									'chat-telegram'
								) }
							/>
							<ToggleControl
								label={ __(
									'Open link in new window',
									'chat-telegram'
								) }
								checked={ buttonLinkTarget }
								onChange={ onButtonLinkTarget }
							/>
						</PanelBody>
						<PanelBody
							title={ __( 'Button Style', 'chat-telegram' ) }
							initialOpen={ false }
						>
							<TextControl
								label={ __( 'Button Text', 'chat-telegram' ) }
								value={ text }
								onChange={ ( val ) =>
									setAttributes( { text: val } )
								}
							/>
							<SelectControl
								label={ __( 'Button Size', 'chat-telegram' ) }
								value={ buttonSize }
								options={ buttonSizeOptions.map(
									( { value, label } ) => ( {
										value,
										label,
									} )
								) }
								onChange={ ( newSize ) => {
									setAttributes( { buttonSize: newSize } );
								} }
							/>
							<SelectControl
								label={ __( 'Border Radius', 'chat-telegram' ) }
								value={ borderRadius }
								options={ borderRadiusOptions.map(
									( { value, label } ) => ( {
										value,
										label,
									} )
								) }
								onChange={ ( newSize ) => {
									setAttributes( { borderRadius: newSize } );
								} }
							/>
							<SelectControl
								label={ __( 'Visibility on', 'chat-telegram' ) }
								value={ visibility }
								options={ visibilityOn.map(
									( { value, label } ) => ( {
										value,
										label,
									} )
								) }
								onChange={ ( newSize ) => {
									setAttributes( { visibility: newSize } );
								} }
							/>
						</PanelBody>
						<PanelBody
							title={ __( 'Icon', 'chat-telegram' ) }
							initialOpen={ false }
						>
							<ToggleControl
								label={ __( 'Add Icon', 'chat-telegram' ) }
								checked={ iconTarget }
								onChange={ onIconTarget }
							/>
						</PanelBody>
					</InspectorControls>
					<BlockControls>
						<AlignmentToolbar
							value={ textAlignment }
							onChange={ onChangeAlignment }
						/>
					</BlockControls>
					<div
						className={ `button-wrapper teleSupport-editor ${ textClasses }` }
					>
						<a
							{ ...useBlockProps( {
								className: `${ basicBtn } ${ buttonSize } ${ borderRadius } ${ visibility }`,
							} ) }
						>
							{ iconTarget && (
								<span className="dashicons dashicons-format-chat"></span>
							) }
							<RichText
								onChange={ onChangeText }
								value={ text }
								placeholder={ __(
									'How can I help you?',
									'chat-telegram'
								) }
								tagName="span"
								allowedFormats={ [] }
							/>
						</a>
					</div>
				</>
			) : (
				<>
					<InspectorControls>
						<PanelBody
							title={ __( 'General Settings', 'chat-telegram' ) }
							initialOpen={ false }
						>
							<TextControl
								label={ __( 'Chanel Link Name', 'chat-telegram' ) }
								value={ numberInput }
								onChange={ ( val ) =>
									setAttributes( { numberInput: val } )
								}
								help={ __(
									'Add your telegram chanel link name',
									'chat-telegram'
								) }
							/>
							<ToggleControl
								label={ __(
									'Open link in new window',
									'chat-telegram'
								) }
								checked={ buttonLinkTarget }
								onChange={ onButtonLinkTarget }
							/>
							<MediaUpload
								label={ __( 'Agent Image', 'chat-telegram' ) }
								onSelect={ onSelectImage }
								allowedTypes={ [ 'image' ] }
								render={ ( { open } ) => (
									<Button
										onClick={ open }
										style={ {
											marginBottom: '20px',
											fontSize: '16px',
										} }
									>
										<span
											style={ { marginRight: '5px' } }
											className="dashicons dashicons-cloud-upload"
										></span>{ ' ' }
										Agent photo
									</Button>
								) }
							/>
							<TextControl
								label={ __( 'Agent Info', 'chat-telegram' ) }
								value={ info }
								onChange={ ( val ) =>
									setAttributes( { info: val } )
								}
								help={ __(
									'Write agent name & agent title',
									'chat-telegram'
								) }
							/>
							<TextControl
								label={ __( 'Button Label', 'chat-telegram' ) }
								value={ title }
								onChange={ ( val ) =>
									setAttributes( { title: val } )
								}
								help={ __(
									'Add custom button label',
									'chat-telegram'
								) }
							/>
							<TextControl
								label={ __(
									'Online Badge Text',
									'chat-telegram'
								) }
								value={ online }
								onChange={ ( val ) =>
									setAttributes( { online: val } )
								}
								help={ __(
									'Add custom badget text when user in online.',
									'chat-telegram'
								) }
							/>
							<TextControl
								label={ __(
									'Offline Badge Text',
									'chat-telegram'
								) }
								value={ offline }
								onChange={ ( val ) =>
									setAttributes( { offline: val } )
								}
								help={ __(
									'Add custom badget text when user in offline.',
									'chat-telegram'
								) }
							/>
						</PanelBody>
						<PanelBody
							title={ __( 'Chat Settings', 'chat-telegram' ) }
							initialOpen={ false }
						>
							<ComboboxControl
								label={ __( 'Timezone', 'chat-telegram' ) }
								value={ timeZone }
								options={ filteredOptions }
								onChange={ onFontSizeChange }
								onInputChange={ onInputChange }
								help={ __(
									'When using the date and time from the user browser you can transform it to your current timezone (in case your user is in a different timezone)',
									'chat-telegram'
								) }
							/>
							<PanelBody
								title={ __( 'Monthday', 'chat-telegram' ) }
								initialOpen={ false }
							>
								<TextControl
									label={ __( 'Start Time', 'chat-telegram' ) }
									value={ mondayStart }
									onChange={ ( val ) =>
										setAttributes( { mondayStart: val } )
									}
									placeholder={ __(
										'00:00',
										'chat-telegram'
									) }
								/>
								<TextControl
									label={ __( 'End Time', 'chat-telegram' ) }
									value={ mondayEnd }
									onChange={ ( val ) =>
										setAttributes( { mondayEnd: val } )
									}
									placeholder={ __(
										'24:00',
										'chat-telegram'
									) }
								/>
							</PanelBody>
							<PanelBody
								title={ __( 'Tuesday', 'chat-telegram' ) }
								initialOpen={ false }
							>
								<TextControl
									label={ __( 'Start Time', 'chat-telegram' ) }
									value={ tuesdayStart }
									onChange={ ( val ) =>
										setAttributes( { tuesdayStart: val } )
									}
									placeholder={ __(
										'00:00',
										'chat-telegram'
									) }
								/>
								<TextControl
									label={ __( 'End Time', 'chat-telegram' ) }
									value={ tuesdayEnd }
									onChange={ ( val ) =>
										setAttributes( { tuesdayEnd: val } )
									}
									placeholder={ __(
										'24:00',
										'chat-telegram'
									) }
								/>
							</PanelBody>
							<PanelBody
								title={ __( 'Wednesday', 'chat-telegram' ) }
								initialOpen={ false }
							>
								<TextControl
									label={ __( 'Start Time', 'chat-telegram' ) }
									value={ wednesdayStart }
									onChange={ ( val ) =>
										setAttributes( { wednesdayStart: val } )
									}
									placeholder={ __(
										'00:00',
										'chat-telegram'
									) }
								/>
								<TextControl
									label={ __( 'End Time', 'chat-telegram' ) }
									value={ wednesdayEnd }
									onChange={ ( val ) =>
										setAttributes( { wednesdayEnd: val } )
									}
									placeholder={ __(
										'24:00',
										'chat-telegram'
									) }
								/>
							</PanelBody>
							<PanelBody
								title={ __( 'Thursday', 'chat-telegram' ) }
								initialOpen={ false }
							>
								<TextControl
									label={ __( 'Start Time', 'chat-telegram' ) }
									value={ thursdayStart }
									onChange={ ( val ) =>
										setAttributes( { thursdayStart: val } )
									}
									placeholder={ __(
										'00:00',
										'chat-telegram'
									) }
								/>
								<TextControl
									label={ __( 'End Time', 'chat-telegram' ) }
									value={ thursdayEnd }
									onChange={ ( val ) =>
										setAttributes( { thursdayEnd: val } )
									}
									placeholder={ __(
										'24:00',
										'chat-telegram'
									) }
								/>
							</PanelBody>
							<PanelBody
								title={ __( 'Friday', 'chat-telegram' ) }
								initialOpen={ false }
							>
								<TextControl
									label={ __( 'Start Time', 'chat-telegram' ) }
									value={ fridayStart }
									onChange={ ( val ) =>
										setAttributes( { fridayStart: val } )
									}
									placeholder={ __(
										'00:00',
										'chat-telegram'
									) }
								/>
								<TextControl
									label={ __( 'End Time', 'chat-telegram' ) }
									value={ fridayEnd }
									onChange={ ( val ) =>
										setAttributes( { fridayEnd: val } )
									}
									placeholder={ __(
										'24:00',
										'chat-telegram'
									) }
								/>
							</PanelBody>
							<PanelBody
								title={ __( 'Saturday', 'chat-telegram' ) }
								initialOpen={ false }
							>
								<TextControl
									label={ __( 'Start Time', 'chat-telegram' ) }
									value={ saturdayStart }
									onChange={ ( val ) =>
										setAttributes( { saturdayStart: val } )
									}
									placeholder={ __(
										'00:00',
										'chat-telegram'
									) }
								/>
								<TextControl
									label={ __( 'End Time', 'chat-telegram' ) }
									value={ saturdayEnd }
									onChange={ ( val ) =>
										setAttributes( { saturdayEnd: val } )
									}
									placeholder={ __(
										'24:00',
										'chat-telegram'
									) }
								/>
							</PanelBody>
							<PanelBody
								title={ __( 'Sunday', 'chat-telegram' ) }
								initialOpen={ false }
							>
								<TextControl
									label={ __( 'Start Time', 'chat-telegram' ) }
									value={ sundayStart }
									onChange={ ( val ) =>
										setAttributes( { sundayStart: val } )
									}
									placeholder={ __(
										'00:00',
										'chat-telegram'
									) }
								/>
								<TextControl
									label={ __( 'End Time', 'chat-telegram' ) }
									value={ sundayEnd }
									onChange={ ( val ) =>
										setAttributes( { sundayEnd: val } )
									}
									placeholder={ __(
										'24:00',
										'chat-telegram'
									) }
								/>
							</PanelBody>
						</PanelBody>
						<PanelBody
							title={ __(
								'Appearance settings',
								'chat-telegram'
							) }
							initialOpen={ false }
						>
							<SelectControl
								label={ __( 'Visibility on', 'chat-telegram' ) }
								value={ visibility }
								options={ visibilityOn.map(
									( { value, label } ) => ( {
										value,
										label,
									} )
								) }
								onChange={ ( newSize ) => {
									setAttributes( { visibility: newSize } );
								} }
							/>
							<SelectControl
								label={ __( 'Size', 'chat-telegram' ) }
								value={ buttonSize }
								options={ buttonSizeOptions.map(
									( { value, label } ) => ( {
										value,
										label,
									} )
								) }
								onChange={ ( newSize ) => {
									setAttributes( { buttonSize: newSize } );
								} }
							/>
							<SelectControl
								label={ __( 'Border Radius', 'chat-telegram' ) }
								value={ borderRadius }
								options={ borderRadiusOptions.map(
									( { value, label } ) => ( {
										value,
										label,
									} )
								) }
								onChange={ ( newSize ) => {
									setAttributes( { borderRadius: newSize } );
								} }
							/>
						</PanelBody>
					</InspectorControls>
					<BlockControls>
						<AlignmentToolbar
							value={ textAlignment }
							onChange={ onChangeAlignment }
						/>
					</BlockControls>
					<div
						className={ `button-wrapper teleSupport-editor ${ textClasses }` }
					>
						<button
							{ ...useBlockProps( {
								className: `avatar-active ${ classes } ${ buttonSize } ${ borderRadius } ${ visibility }`,
							} ) }
							data-btnavailablety={ `{ "monday":"${ mondayStart }-${ mondayEnd }", "tuesday":"${ tuesdayStart }-${ tuesdayEnd }", "wednesday":"${ wednesdayStart }-${ wednesdayEnd }", "thursday":"${ thursdayStart }-${ thursdayEnd }", "friday":"${ fridayStart }-${ fridayEnd }", "saturday":"${ saturdayStart }-${ saturdayEnd }", "sunday":"${ sundayStart }-${ sundayEnd }" }` }
							data-timezone={ timeZone }
						>
							<img
								src={ imageUrl ? imageUrl : agentImage }
								alt="agent"
							/>
							<div className="info-wrapper">
								<RichText
									onChange={ advancedBtnInfo }
									value={ info }
									placeholder={ __(
										'Robert / Sales Support',
										'chat-telegram'
									) }
									tagName="p"
									allowedFormats={ [] }
									className="info"
								/>
								<RichText
									onChange={ advancedBtnTitle }
									value={ title }
									placeholder={ __(
										'How can I help you?',
										'chat-telegram'
									) }
									tagName="p"
									allowedFormats={ [] }
									className="title"
								/>
								<RichText
									onChange={ advancedBtnOnlineBadge }
									value={ online }
									placeholder={ __(
										'I am online',
										'chat-telegram'
									) }
									tagName="p"
									allowedFormats={ [] }
									className="online"
								/>
								<RichText
									onChange={ advancedBtnOnlineBadge }
									value={ offline }
									placeholder={ __(
										"I'm not available",
										'chat-telegram'
									) }
									tagName="p"
									allowedFormats={ [] }
									className="offline"
								/>
							</div>
						</button>
					</div>
				</>
			) }
		</>
	);
}
